import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule, Location } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PersonasSidebarComponent } from '../../features/personas/shared/personas-sidebar/personas-sidebar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppIcons } from '@core/utilities/icons';

@Component({
    selector: 'app-personas-layout',
    standalone: true,
    imports: [CommonModule, RouterLink, RouterOutlet, PersonasSidebarComponent, FontAwesomeModule],
    templateUrl: './personas-layout.component.html',
    styleUrls: ['./personas-layout.component.scss']
})
export class PersonasLayoutComponent {
    readonly icons = AppIcons;

    private readonly router = inject(Router);
    private readonly location = inject(Location);
    private readonly destroyRef = inject(DestroyRef);

    isSidebarOpen = false;
    /**
     * true = botón «Volver»; false = menú hamburguesa.
     * En inicio (listado) y en resumen de crédito va hamburguesa.
     */
    showMobileBack = false;
    hideSidebar = false;

    constructor() {
        this.router.events
            .pipe(
                filter((e): e is NavigationEnd => e instanceof NavigationEnd),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe((e) => {
                this.isSidebarOpen = false;
                this.showMobileBack = !this.isMobileHamburgerRoute(e.urlAfterRedirects);
                this.hideSidebar = this.isRolloverFlowRoute(e.urlAfterRedirects);
            });

        this.showMobileBack = !this.isMobileHamburgerRoute(this.router.url);
        this.hideSidebar = this.isRolloverFlowRoute(this.router.url);
    }

    /** Rutas donde el header móvil muestra hamburguesa (no «Volver»). */
    private isMobileHamburgerRoute(url: string): boolean {
        const path = (url.split('?')[0].replace(/\/$/, '') || '/').toLowerCase();
        return (
            path === '/personas/inicio' ||
            path === '/personas' ||
            path === '/personas/creditos'
        );
    }

    private isRolloverFlowRoute(url: string): boolean {
        const path = (url.split('?')[0].replace(/\/$/, '') || '/').toLowerCase();
        return (
            path === '/personas/nuevo-desembolso' ||
            path === '/personas/documentos-credito' ||
            path === '/personas/proceso-terminado'
        );
    }

    toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
    }

    closeSidebar() {
        this.isSidebarOpen = false;
    }

    mobileGoBack(): void {
        if (window.history.length > 1) {
            this.location.back();
        } else {
            void this.router.navigate(['/personas/inicio']);
        }
    }
}
